import { Routes, Route } from "react-router-dom";
import React, { useEffect } from 'react';

import Static from "./Layouts/static";
import Home from "./Pages/Home";
import AboutPage from "./Pages/About";
import HotelCatalog from "./Pages/Hotels/HotelCatalog";
import HotelDetail from "./Pages/Hotels/HotelDetail"; // Nuevo componente dinámico
import NotFound from "./Pages/NotFound";
import Arrepentimientodecompra from "./Pages/Arrepentimientodecompra";
import ScrollToTop from "./hooks/ScrollToTop";
 import TagManager from 'react-gtm-module';

// const tagManagerArgs = {
//     gtmId: 'GTM-XXXXXXX' // Reemplaza con tu ID real
// };
 


// TagManager.initialize(tagManagerArgs);

function App() {

 useEffect(() => {
           const tagManagerArgs = {
               gtmId: 'GTM-52VFPDTR'
           };
           TagManager.initialize(tagManagerArgs);
       }, []);


  return (
    <>
    
      <ScrollToTop />
      <Routes>
        <Route element={<Static />}>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<AboutPage />} />
          <Route path="/hoteles" element={<HotelCatalog />} />
          {/* Ruta dinámica para hoteles */}
          <Route path="/hoteles/:slug/:idHotel" element={<HotelDetail />} />
          <Route path="/arrepentimientodecompra" element={<Arrepentimientodecompra />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;